module.exports = __webpack_public_path__ + "img/pixing_zc_zhangpin.31d7867f.jpg";